import { render, staticRenderFns } from "./cargoDeclareBalance.vue?vue&type=template&id=35b16368&scoped=true&"
import script from "./cargoDeclareBalance.vue?vue&type=script&lang=js&"
export * from "./cargoDeclareBalance.vue?vue&type=script&lang=js&"
import style0 from "./cargoDeclareBalance.vue?vue&type=style&index=0&id=35b16368&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b16368",
  null
  
)

export default component.exports